import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import loginLogo from "../../images/login-logo.png";
import { useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword , signInWithEmailAndPassword } from "firebase/auth";
import {auth} from '../../firebase'
import { useState } from "react";


export default function Login() {
    const navigate = useNavigate();

    const [email , setEmail]= useState("");
    const [pass , setPass]= useState("");
    const [name , setName] = useState("");

    const register = (e)=> {
        e.preventDefault();
        createUserWithEmailAndPassword(auth, email , pass)
        .then((auth)=> {
            if(auth){
                navigate("/");
            }
        }).catch((error)=> {alert(error.message)})
    };

    const signIn = (e) => {
        e.preventDefault();
        signInWithEmailAndPassword(auth , email , pass)
        .then((auth)=> {
            if(auth){
                navigate("/");
            }
        }).catch((error)=> {alert(error.message)})
    }

  return (
    <Box
      sx={{
        // height: "80vh",
        display:"flex",
        flexDirection:"column"
    }}
    component="form"
    noValidate
    autoComplete="off"
    alignItems={"center"}
    justifyContent={"start"}
    >
        <Typography variant="h6" sx={{width:"200px" , display:"block",
            margin:"20px auto"
        }}>
        <img src={loginLogo} alt="login-logo" style={{width:"100%",
            cursor:"pointer"}}
            onClick={()=> navigate("/")}
        />

        </Typography>
      <Stack
        height={"100%"}
        sx={{ 
            bgcolor:"#eee", p:5,
            gap:2, width:"300px",
            alignItems:"center",borderRadius:"10px"
        }}
      >
        <Typography variant="h5" sx={{
            fontFamily:"sans-serif",
            fontWeight:600,
            letterSpacing:"1.1px",
            marginRight:"auto",
            marginBottom:"10px",

        }}>Sign In</Typography>
        <TextField
          id="outlined-name"
          type="text"
          label="User Name"
          variant="outlined"
          value={name}
          onChange={(e)=> setName(e.target.value)}
          sx={{width:"300px"}}
          />
        <TextField
          id="outlined-email"
          type="email"
          label="Email"
          variant="outlined"
          value={email}
          onChange={(e)=> setEmail(e.target.value)}
          sx={{width:"300px"}}
          />
        <TextField
          id="outlined-password"
          type="password"
          label="Password"
          value={pass}
          variant="outlined"
          sx={{width:"300px"}}
          onChange={(e)=> setPass(e.target.value)}
          />
          <Button sx={{width:"100%",

            color:"#111",bgcolor:"#fcd115",borderColor:"#fcd115"
            ,"&:hover":{bgcolor:"#e2bc10"}
          }} variant="outlined"
          onClick={signIn}
          >Login</Button>

            <Typography variant="subtitle1" sx={{width:"100%" ,color:"#555"}}>
            By continuing, you agree to Amazon`s Fake conditions of Use and
            Privacy Notice
            </Typography>

          <Button sx={{width:"100%" , color:"#666", borderColor:"#999"
            ,"&:hover":{bgcolor:"#c4c2c2"}
          }} variant="outlined"
          onClick={register}
          >Create Account</Button>

      </Stack>
      
    </Box>
  );
}
